import { render } from "./MasterTable.vue?vue&type=template&id=2a613db8"
import script from "./MasterTable.vue?vue&type=script&lang=js"
export * from "./MasterTable.vue?vue&type=script&lang=js"

import "./MasterTable.vue?vue&type=style&index=0&id=2a613db8&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__